import { Autocomplete, Box, Button, ButtonGroup, CircularProgress, FormControl, IconButton, InputLabel, MenuItem, Select, SwipeableDrawer, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from '@mui/icons-material/Close';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";

export interface Filter {
    id: number;
    name: string;
    action: string;
    value: any;
    field?: string;
    inputValueFilter?: string;
}

export interface FilterList {
    name: string;
    type: string;
    field: string;
    subField?: string;
    buttons: any[];
    options: any[];
    action?: string;
}

export interface FilterDrawerProps {
    showFilters: boolean;
    filters: FilterList[];
    filteredData: Filter[];
    setshowFilters: (value: boolean) => void;
    handleSelectOptionFilter: (filter: any) => void;
    resetFilters?: () => void;
    onQueryAction?: () => void;
    loadingQuery?: boolean;
}

export const FilterDrawer = ({ showFilters, setshowFilters, filters, handleSelectOptionFilter, filteredData, resetFilters, onQueryAction, loadingQuery }: FilterDrawerProps) => {
    return (
        <SwipeableDrawer
            anchor="right"
            open={showFilters}
            onClose={() => setshowFilters(!showFilters)}
            onOpen={() => setshowFilters(true)}
        >
            <Grid
                size={12}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                    width: '300px',
                    padding: '10px',
                }}>
                <Grid sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #ccc',
                    alignItems: 'center',
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#fff',
                    zIndex: 2,
                }}>
                    <Typography variant="body1" color="primary" sx={{ fontWeight: 'bold', fontSize: '15px', textAlign: 'center' }}>Filtrar Por</Typography>
                    <Grid>
                        {resetFilters && (
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => resetFilters()}
                            >
                                <RestartAltOutlinedIcon fontSize="small" />
                            </IconButton>
                        )}
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => setshowFilters(!showFilters)}
                        >
                            <CloseIcon />
                        </IconButton>

                    </Grid>


                </Grid>
                {filters.map((filter, index) => (
                    <Box sx={{ display: 'flex', flexDirection: 'column', padding: '10px', borderBottom: '1px solid #ccc' }} key={index}>
                        <Typography variant="body1" color="initial" sx={{ fontWeight: 'bold', fontSize: '12px', textAlign: 'center', mb: 2 }}>{filter.name}</Typography>
                        {filter?.type === 'groupButton' && (
                            <Grid sx={{ display: 'flex', gap: '5px', justifyContent: 'center', alignContent: 'center' }}>
                                <ButtonGroup
                                    variant="outlined"
                                    aria-label="outlined button group"
                                    sx={{ mt: 1 }}
                                >
                                    {filter.buttons.map((button, index) => (
                                        <Button
                                            key={index}
                                            variant={filteredData.some(f => f.name === filter.name && f.id === button.id) ? "contained" : "outlined"}
                                            onClick={(e) => handleSelectOptionFilter({ id: button.id, name: filter.name, value: button.value, action: button.action, field: filter.field, })}
                                            size="small"
                                        >
                                            {button.name}
                                        </Button>
                                    ))}
                                </ButtonGroup>
                            </Grid>
                        )}

                        {filter?.type === 'boolean' && (
                            <Grid sx={{ display: 'flex', gap: '5px', justifyContent: 'center', alignContent: 'center' }}>
                                <ButtonGroup
                                    variant="outlined"
                                    aria-label="outlined button group"
                                    sx={{ mt: 1 }}
                                >
                                    {[
                                        { id: 0, name: 'Todo', value: '', action: 'dissable' },
                                        { id: 1, name: 'SI', value: true, action: 'equal' },
                                        { id: 2, name: 'NO', value: false, action: 'equal' }
                                    ].map((button, index) => (
                                        <Button
                                            key={index}
                                            variant={filteredData.some(f => f.name === filter.name && f.id === button.id) ? "contained" : "outlined"}
                                            onClick={(e) => handleSelectOptionFilter({ id: button.id, name: filter.name, value: button.value, action: button.action, field: filter.field, })}
                                            size="small"
                                        >
                                            {button.name}
                                        </Button>
                                    ))}
                                </ButtonGroup>
                            </Grid>
                        )}

                        {filter?.type === 'Autocomplete' && (
                            <Autocomplete
                                multiple
                                id="size-small-standard-multi"
                                size="small"
                                options={filter.options}
                                value={filteredData.find(f => f.name === filter.name)?.value || []}
                                onChange={(event: any, newValue: any) => handleSelectOptionFilter({ id: 0, name: filter.name, value: newValue, action: filter.action, field: filter.field })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="standard"
                                    />
                                )}
                            />
                        )}

                        {filter?.type === 'text' && (
                            <TextField
                                id="outlined-basic"
                                label={filter.name}
                                variant="outlined"
                                size="small"
                                name={filter.field}
                                value={filteredData.find(f => f.name === filter.name)?.value ?? ''}
                                onChange={(e) =>
                                    handleSelectOptionFilter({
                                        id: 0,
                                        name: filter.name,
                                        field: filter.field,
                                        action: filter.action,
                                        value: e.target.value,
                                    })
                                }
                            />
                        )}

                        {filter?.type === 'date' && (
                            <DesktopDatePicker
                                label={filter.name}
                                sx={{
                                    width: "100%",
                                }}
                                name={filter.field}
                                value={filteredData.find(f => f.name === filter.name)?.value ?? null}
                                onChange={(date) =>
                                    handleSelectOptionFilter({
                                        id: 0,
                                        name: filter.name,
                                        field: filter.field,
                                        action: filter.action,
                                        value: date ?? moment(),
                                    })
                                }
                            />
                        )}
                        {filter?.type === 'select' && (
                            <FormControl fullWidth>
                                <InputLabel
                                    id="demo-simple-select-label"
                                    size="small"
                                >
                                    {filter.name}
                                </InputLabel>
                                <Select
                                    size="small"
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={filteredData.find(f => f.name === filter.name)?.value || ""}
                                    label="Proyecto"
                                    onChange={(e) =>
                                        handleSelectOptionFilter({
                                            id: 0,
                                            name: filter.name,
                                            field: filter.field,
                                            action: filter.action,
                                            value: e.target.value,
                                        })
                                    }
                                >
                                    {filter?.options.map((f, index) => (
                                        <MenuItem
                                            key={index}
                                            value={f.id}
                                        >
                                            {" "}
                                            {f.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </Box>
                ))}
                {onQueryAction && (
                    <Button
                        variant="contained"
                        onClick={() => onQueryAction()}
                        fullWidth
                        disabled={!!loadingQuery}
                        startIcon={
                            loadingQuery ? (
                                <CircularProgress size={18} color="inherit" />
                            ) : undefined
                        }
                    >
                        {loadingQuery ? "Consultando..." : "Consultar"}
                    </Button>
                )}
            </Grid>
        </SwipeableDrawer>
    )
}